<template>
  <div class="list-list-container">
    <h1 class="list-title">진행중인 설문</h1>
    <p class="list-sub-title">
      지금 서베이지에서 응답을 모으고 있는 설문이에요. 앱을 설치하면 참여하고 리워드를 받을 수 있어요.
    </p>

    <div class="list-stats-grid">
      <div class="list-stat-card list-stat-card--highlight">
        <span class="list-stat-label">진행중인 설문</span>
        <span class="list-stat-value">{{ progressCount }}건</span>
      </div>
      <div class="list-stat-card">
        <span class="list-stat-label">오늘 마감</span>
        <span class="list-stat-value">{{ dueTodayCount }}건</span>
      </div>
      <div class="list-stat-card">
        <span class="list-stat-label">참여 가능 패널</span>
        <span class="list-stat-value">1,008명</span>
      </div>
      <div class="list-stat-card">
        <span class="list-stat-label">누적 설문</span>
        <span class="list-stat-value">2,684</span>
      </div>
    </div>

    <div class="list-toolbar">
      <div class="list-tabs">
        <button
          class="list-tab"
          v-for="tab in tabs"
          :key="tab.value"
          :class="{ 'list-tab--active': activeTab === tab.value }"
          @click="activeTab = tab.value"
        >{{ tab.label }}</button>
      </div>
      <select class="list-sort" v-model="sortKey">
        <option value="deadline">마감 임박순</option>
        <option value="latest">최신순</option>
      </select>
    </div>

    <div class="list-list-item-container">
      <div
        class="list-list-item"
        :class="{ 'done': item.isDone, 'clickable': !item.isDone }"
        v-for="item in displayedList"
        :key="item.id"
        @click="openSurvey(item)"
      >
        <div class="list-list-item-top-container">
          <span class="list-list-item-top" id="list-done" v-if="item.isDone">마감</span>
          <span class="list-list-item-top" v-else-if="item.dday == 0 && item.dtime >= 0">{{ item.dtime }}시간 남음</span>
          <span class="list-list-item-top" v-else-if="item.dday == 0 && item.dtime < 0">0시간 남음</span>
          <span class="list-list-item-top" v-else>{{ item.dday }}일 남음</span>

        </div>
        <div class="list-list-item-title">{{ item.title }}</div>

        <div class="list-list-item-line"></div>

        <div class="list-list-item-bottom-container">
          <div class="list-list-item-bottom-item">
            <span class="list-list-item-option-done" v-if="item.isDone">설문 대상</span>
            <span class="list-list-item-option" v-else>설문 대상</span>
            <span class="text-done" v-if="item.tarInput == null">모두</span>
            <span class="text-done" v-else-if="item.tarInput.length > 15">{{item.tarInput.substring(0,15)}}...</span>
            <span class="text-done" v-else>{{item.tarInput}}</span>
          </div>
          <div class="list-list-item-bottom-item">
            <span class="list-list-item-option-done" v-if="item.isDone">응답수</span>
            <span class="list-list-item-option" v-else>응답수</span>
            <span class="text-done" v-if="item.isDone">{{ item.headCount }}명</span>
            <span v-else><span>{{ item.responseCount }}명 / </span><span>{{ item.headCount }}명</span></span>
          </div>
          <div class="list-list-item-bottom-item">
            <span class="list-list-item-option-done" v-if="item.isDone">의뢰자</span>
            <span class="list-list-item-option" v-else>의뢰자</span>
            <span class="text-done" v-if="item.isDone">{{ item.username.substring(0, item.username.length - 1) + "*" }} </span>
            <span v-else>{{ item.username.substring(0, item.username.length - 1) + "*" }} </span>
          </div>
        </div>
        <div class="list-list-item-progress-bar">
          <div class="list-list-item-progress-fill" :style="{ width: progressPercent(item) + '%' }"></div>
        </div>
      </div>
    </div>
    <div ref="loadMoreSentinel" class="load-more-sentinel">
      <span class="load-more-loading" v-if="loading">불러오는 중…</span>
      <span class="load-more-end" v-else-if="reachedEnd">모든 설문을 확인했어요</span>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      surveyList: [],
      pageInfo : [],
      pageCnt : -1,
      loading: false,
      requireHeadCountText: this.$store.state.tables.priceTextTable[0],
      activeTab: 'progress',
      sortKey: 'deadline',
      tabs: [
        { label: '진행중', value: 'progress' },
        { label: '완료', value: 'done' },
        { label: '전체', value: 'all' }
      ]
    }

  },
  computed: {
    displayedList() {
      let list = this.surveyList
      if (this.activeTab === 'progress') list = list.filter(item => !item.isDone)
      else if (this.activeTab === 'done') list = list.filter(item => item.isDone)

      if (this.sortKey === 'deadline') {
        list = [...list].sort((a, b) => {
          if (a.isDone !== b.isDone) return a.isDone ? 1 : -1
          const aHours = a.dday * 24 + a.dtime
          const bHours = b.dday * 24 + b.dtime
          return aHours - bHours
        })
      }
      return list
    },
    reachedEnd() {
      return this.pageInfo.pageNum != null && this.pageInfo.pageNum >= this.pageInfo.totalPages - 1
    },
    // API에 상태별 집계 엔드포인트가 없어(전체 개수만 내려줌) 지금까지
    // 불러온 목록 기준으로 센다 — 스크롤할수록 정확해지지만 전체 총합은 아니다.
    // 참여 가능 패널·누적 설문은 아예 가져올 방법이 없어 하드코딩 유지.
    progressCount() {
      return this.surveyList.filter(item => !item.isDone).length
    },
    dueTodayCount() {
      return this.surveyList.filter(item => !item.isDone && item.dday === 0).length
    }
  },
  mounted() {
    this.listSurveys()
    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) this.listSurveys()
    })
    this.observer.observe(this.$refs.loadMoreSentinel)
  },
  beforeUnmount() {
    if (this.observer) this.observer.disconnect()
  },
  methods: {
    async listSurveys() {
      if (this.loading || this.reachedEnd) return
      this.loading = true
      try {
        const nextPage = this.pageCnt + 1
        // 카드 그리드가 3열이라 한 번에 6개(정확히 2줄)씩 불러온다 — 10개씩
        // 불러오면 3의 배수가 아니라서 스크롤할 때마다 마지막 줄이 어중간하게
        // 채워진 채로 보였다.
        const response = await axios.get("https://gosurveasy.co.kr/survey/list", {
          params: {
            page: nextPage,
            size: 6
          }
        })

        this.pageCnt = nextPage
        // isDone이 아직 갱신 안 된 채 마감 시간만 지난(dday 0, dtime 음수) 항목이
        // "0시간 남음"으로 진행중 탭에 섞여 보이는 문제 — 마감 지난 건 done으로 취급
        const normalized = response.data.surveyListVos.map(item => ({
          ...item,
          isDone: item.isDone || (item.dday === 0 && item.dtime < 0)
        }))
        this.surveyList = this.surveyList.concat(normalized)
        this.pageInfo = response.data.pageInfo
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    progressPercent(item) {
      if (!item.headCount) return 0
      return Math.min(100, Math.round((item.responseCount / item.headCount) * 100))
    },
    openSurvey(item) {
      // 마감된 설문은 참여 링크로 보낼 이유가 없어 카드 전체를 눌러도 아무 일 없다
      if (item.isDone || !item.link) return
      window.open(item.link, '_blank')
    }
  }
}

</script>

<style scoped>
.list-list-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 40px 24px 80px;
  font-family: var(--font-sans);
}

.list-title {
  margin: 0 0 var(--space-3) 0;
  font-size: 34px;
  font-weight: var(--font-weight-bold);
  color: var(--text-heading);
  text-align: left;
}

.list-sub-title {
  margin: 0 0 var(--space-6) 0;
  font-size: 16px;
  color: var(--text-muted);
  text-align: left;
  line-height: 1.6;
}

.list-stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: var(--space-8);
}

.list-stat-card {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: var(--space-6);
  background-color: var(--surface-card);
  border: 1px solid var(--ink-100);
  border-radius: var(--radius-lg);
  text-align: left;
}

.list-stat-card--highlight {
  background-color: var(--green-50);
  border-color: var(--green-200);
}

.list-stat-label {
  font-size: 13px;
  color: var(--text-muted);
}

.list-stat-value {
  font-size: 24px;
  font-weight: var(--font-weight-bold);
  color: var(--text-heading);
}

.list-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--space-4);
  border-bottom: 1px solid var(--ink-100);
}

.list-tabs {
  display: flex;
  gap: var(--space-6);
}

.list-tab {
  padding: var(--space-3) 0;
  margin-bottom: -1px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  font-family: var(--font-sans);
  font-size: 15px;
  font-weight: var(--font-weight-medium);
  color: var(--text-muted);
  cursor: pointer;
}

.list-tab--active {
  color: var(--green-600);
  border-bottom-color: var(--green-500);
  font-weight: var(--font-weight-semibold);
}

.list-sort {
  font-family: var(--font-sans);
  font-size: 13px;
  color: var(--text-body);
  border: 1px solid var(--ink-200);
  border-radius: var(--radius-sm);
  padding: 6px 8px;
  background-color: var(--white);
}

.list-list-item-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: var(--space-6);
}
.list-list-item {
  padding: var(--space-6);
  border: solid 1px var(--green-500);
  border-radius: var(--radius-lg);
  box-sizing: border-box;
  text-align: left;
  transition: box-shadow .15s ease, border-color .15s ease;
}

.list-list-item.clickable {
  cursor: pointer;
}

.list-list-item.clickable:hover {
  border-color: var(--green-600);
  box-shadow: var(--shadow-sm);
}

.list-list-item.done {
  border: solid 1px var(--ink-300);
}
.list-list-item-top-container {
  display: flex;
  margin-bottom: 10px;
}
.text-done{
  color: var(--text-muted);
}
.list-list-item-top {
  margin-right: 7px;
  padding: 3px 8px;
  border-radius: var(--radius-sm);
  background-color: var(--green-500);
  color: white;
  font-size: 12px;
}
#list-done{
  background-color: var(--ink-400);
}
.list-list-item-title {
  font-size: 15px;
  font-weight: var(--font-weight-semibold);
  text-align: left;
  color: var(--text-heading);
}
.list-list-item-line {
  width: 100%;
  height: 1px;
  margin: 10px 0;
  background-color: var(--ink-100);
}
.list-list-item-bottom-container {
  margin-top: 4px;
}
.list-list-item-bottom-item {
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 8px;
  font-size: 13px;
}
.list-list-item-option {
  margin-right: 7px;
  padding: 3px 6px;
  border: solid 1px var(--green-500);
  border-radius: var(--radius-sm);
  text-align: left;
  color: var(--green-600);
  font-size: 12px;
}

.list-list-item-option-done{
  margin-right: 7px;
  padding: 3px 6px;
  border: solid 1px var(--ink-300);
  border-radius: var(--radius-sm);
  text-align: left;
  color: var(--text-muted);
  font-size: 12px;
}

.list-list-item-progress-bar {
  width: 100%;
  height: 5px;
  margin-top: 10px;
  border-radius: 999px;
  background-color: var(--ink-100);
  overflow: hidden;
}

.list-list-item-progress-fill {
  height: 100%;
  border-radius: 999px;
  background-color: var(--green-500);
}

.list-list-item.done .list-list-item-progress-fill {
  background-color: var(--ink-400);
}

.load-more-sentinel {
  display: flex;
  justify-content: center;
  margin-top: var(--space-8);
  padding: var(--space-4) 0;
}

.load-more-loading,
.load-more-end {
  font-size: 13px;
  color: var(--text-muted);
}

@media (max-width: 900px) {
  .list-stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .list-list-item-container {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 560px) {
  .list-title {
    font-size: 24px;
  }
}
</style>
